import type { CityId } from '@bruce/api/common/city'
import { utils } from '@bruce/utils'

export function changeCity(city: CityId) {
  document.cookie = 'city=; max-age=0; path=/' // Remove cookie from old public web, this line can be removed by 2025-09-06
  document.cookie = `city=${city}; expires=${new Date(new Date().setFullYear(new Date().getFullYear() + 10))}; path=/${window.location.hostname !== 'localhost' ? `; domain=.${utils.getTldFromUrl(new URL(window.location.href))}` : ''}`
}
